// Persian number / date to words (cheque amount "به حروف", date "به حروف").

var ONES = ['', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه'];
var TEENS = ['ده', 'یازده', 'دوازده', 'سیزده', 'چهارده', 'پانزده', 'شانزده', 'هفده', 'هجده', 'نوزده'];
var TENS = ['', '', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'];
var HUNDREDS = ['', 'یکصد', 'دویست', 'سیصد', 'چهارصد', 'پانصد', 'ششصد', 'هفتصد', 'هشتصد', 'نهصد'];
var SCALES = ['', 'هزار', 'میلیون', 'میلیارد', 'هزار میلیارد', 'میلیون میلیارد'];
var AND = ' و ';

function below1000(n) {
  var out = [];
  var h = Math.floor(n / 100);
  var r = n % 100;
  if (h) out.push(HUNDREDS[h]);
  if (r >= 10 && r < 20) out.push(TEENS[r - 10]);
  else {
    var t = Math.floor(r / 10);
    var o = r % 10;
    if (t) out.push(TENS[t]);
    if (o) out.push(ONES[o]);
  }
  return out.join(AND);
}

// 1250000 -> "یک میلیون و دویست و پنجاه هزار"
export function numberToWords(value) {
  var n = Math.floor(Math.abs(Number(String(value == null ? '' : value).replace(/[^\d.-]/g, '')) || 0));
  if (!n) return 'صفر';
  var parts = [];
  var i = 0;
  while (n > 0 && i < SCALES.length) {
    var chunk = n % 1000;
    if (chunk) parts.unshift(below1000(chunk) + (SCALES[i] ? ' ' + SCALES[i] : ''));
    n = Math.floor(n / 1000);
    i++;
  }
  return parts.join(AND);
}

// 11 -> "یازدهم", 3 -> "سوم", 30 -> "سی‌ام"
export function ordinalWords(n) {
  if (Number(n) === 1) return 'یکم';
  var w = numberToWords(n);
  if (/سه$/.test(w)) return w.replace(/سه$/, 'سوم');
  if (/ی$/.test(w)) return w + '‌ام';
  return w + 'م';
}

var MONTHS = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];

// "1405/08/11" (jalali) -> "یازدهم آبان یک هزار و چهارصد و پنج"
export function jalaliDateWords(date) {
  var m = String(date || '').replace(/[۰-۹]/g, function (d) { return '۰۱۲۳۴۵۶۷۸۹'.indexOf(d); }).match(/(\d{4})\D(\d{1,2})\D(\d{1,2})/);
  if (!m) return '';
  var y = Number(m[1]);
  var mo = Number(m[2]);
  var d = Number(m[3]);
  if (!MONTHS[mo - 1]) return '';
  var year = numberToWords(y).replace(/^یک هزار|^هزار/, 'یک هزار');
  return ordinalWords(d) + ' ' + MONTHS[mo - 1] + ' ' + year;
}
